<template>
    <div class="main-content">
        <input class="searchInput" v-model="keyword" placeholder="Search users and groups" type="text" @keyup.enter="search">
        <button class="tube-button wide" @click="search" :disabled='sending'>Search</button>
        <searchItem 		
            v-for="item in searchResult"
            :key="item.uuid"
            :data='item'
            @show-brief='showCard'
        />
        
        <div id="searchPage-modal-card-shadow" :style="{display:status}" class="modal" @click="closeCard">
            <div class="modal-card" >
                <quickProfile :profile='this.cardContent' :display='this.showQuickProfile' />
                <div class="tab" :class="{'hide':!this.$store.state.showSearchPageCreateGroup}">
                    <h1>Create group</h1>
                    <input class="tube-input" v-model="groupName" placeholder="group name" type="text">
                    <div class='blank'></div>
                    <input class="tube-input" v-model="des" placeholder="group description" type="text">
                    <div class='blank'></div>
                    <button class="wide tube-button" @click="createGroup">create</button>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
import searchItem from "@/components/searchItem.vue"
import quickProfile from "@/components/quickProfile.vue"

export default {
    name: 'searchPage',
    components: {
        searchItem,
        quickProfile
    },
    data: function(){
        return{
            keyword:'',
            sending:false,
            searchResult:[],
            modalOpen:false,
            cardContent:{},
            lastSearch:'',
            showQuickProfile:false,
            sending:false,
            groupName:'',
            des:'',
            lastCreateName:'',
            lastCreateDes:''
        }
    },
    methods: {
        search:function(){
            if(this.keyword.trim() !== '' && this.keyword !== this.lastSearch){
                this.sending=true;
                this.sending=this.keyword;
                this.$socket.emit('search',{keyword:this.keyword.trim()});
            }
        },
        closeCard:function(){
            let modal = document.getElementById('searchPage-modal-card-shadow');
            if (event.target == modal) {
                this.showQuickProfile=false;
                this.$store.state.searchPageModalOpen=false;
            }
        },
        showCard:function(payload){
            switch(payload.showWhat){
                case 'quickProfile':
                    this.$store.state.showSearchPageCreateGroup=false;
                    this.showQuickProfile=true;
                    this.cardContent=payload;
                    break;
                case 'createGroup':
                    this.showQuickProfile=false;
                    break;
            }
            this.$store.state.searchPageModalOpen=true;
        },
        createGroup(){
            if(this.lastCreateName !== this.groupName && this.lastCreateDes !== this.des && this.groupName.trim() !== '' && this.des.trim() !== ''){
                this.lastCreateName=this.groupName;
                this.lastCreateDes=this.des;
                this.$socket.emit('groupAction',{action:'create',title:this.groupName,des:this.des});
            }
			
		}
    },
    mounted(){
        this.$store.state.nowTitle='Search';
    },
    sockets:{
        searchBack: function(payload){
            this.searchResult=payload;
            this.sending=false;
        }
    },
    computed:{
        status(){
            if(this.$store.state.searchPageModalOpen===false){
                return 'none'
            }
            return 'block'
        }
    }
}
</script>

<style>
    .searchInput {
        height:48px;
        box-shadow: inset 0px 0px 2px 2px rgba(216, 216, 216, 0.596);
        outline:none;
        border:1px solid rgb(216, 216, 216);
        padding-left:6px;
        padding-right:6px;
        font-size: 24px;
    }
</style>

